import React from "react";

const OrderTimeline = ({ steps, current, config }) => {
  const currentIndex = steps.indexOf(current);

  return (
    <div className="owm-timeline">
      {steps.map((step, index) => {
        const Icon = config[step]?.icon;
        const state =
          index < currentIndex
            ? "done"
            : index === currentIndex
            ? "active"
            : "pending";

        return (
          <div key={step} className={`owm-timeline-step ${state}`}>
            {index !== 0 && <span className="owm-timeline-connector" />}

            <div className="owm-timeline-node">
              {Icon && <Icon />}
            </div>

            <span className="owm-timeline-label">
              {config[step]?.label || step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default OrderTimeline;
